angular.module('dnecom')
    .service('ErrorBag', function () {
        const Bag = function(errorsList) {
            return {
                _list: errorsList,

                has(key) {
                    return typeof errorsList[key] !== 'undefined';
                },

                clear(key) {
                    delete errorsList[key];
                },

                messages(key) {
                    return errorsList[key];
                }
            };
        };

        return {
            from(errorsList) {
                return new Bag(errorsList);
            }
        }
    });
